import { appEnv } from '../../env';
export var CurrencyTokenSymbol;
(function (CurrencyTokenSymbol) {
    CurrencyTokenSymbol["CTA"] = "CTA";
    CurrencyTokenSymbol["USDC"] = "USDC";
    CurrencyTokenSymbol["IMX"] = "IMX";
    CurrencyTokenSymbol["ETH"] = "ETH";
})(CurrencyTokenSymbol || (CurrencyTokenSymbol = {}));
export var currencyTokens = [
    {
        symbol: CurrencyTokenSymbol.CTA,
        address: appEnv.ctaTokenAddress,
    },
    {
        symbol: CurrencyTokenSymbol.USDC,
        address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    },
    {
        symbol: CurrencyTokenSymbol.IMX,
        address: '0xf57e7e7c23978c3caec3c3548e3d615c346e79ff',
    },
    {
        symbol: CurrencyTokenSymbol.ETH,
        address: '',
    },
];
export var currencyTokensWithEnv = [
    {
        symbol: CurrencyTokenSymbol.CTA,
        address: appEnv.ctaTokenAddress,
    },
    {
        symbol: CurrencyTokenSymbol.USDC,
        address: appEnv.usdcTokenAddress,
    },
    {
        symbol: CurrencyTokenSymbol.IMX,
        address: appEnv.imxTokenAddress,
    },
    {
        symbol: CurrencyTokenSymbol.ETH,
        address: '',
    },
];
export var imxAddressL1AddressMap = {
    '0xca6c31cc71fb8f00dc2c465299f605039e0e1f4b': appEnv.usdcTokenAddress,
};
